export enum DeactivationReason {
  ACTIVE = 'ACTIVE',
  CAPTIVITY = 'CAPTIVITY',
  BLK = 'BLK',
  'ILLIGAL ACTIONS' = 'ILLIGAL ACTIONS',
  OTHER = 'OTHER',
}
